import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../../global/global.service';
import { Subscription } from 'rxjs';
import { CategoryService } from '../../_services/category.service';
import { CategoryResponse } from '../../_models/category';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { ResponseStructure } from '@iq-central-front-end/share';

@Component({
  selector: 'iq-central-front-end-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  categories: CategoryResponse[] = [];
  subCategories: CategoryResponse[] = [];
  topics: CategoryResponse[] = [];
  subCategoryForm: FormGroup;
  categoryForm: FormGroup;
  topicForm: FormGroup;
  IsHidden = true;
  catName: any;
  subcatName: any;
  catId: any;
  subcatId: any;
  constructor(
    private http: HttpClient,
    private _global: GlobalService,
    private _category: CategoryService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.getAllCategories();
    this.initAddTopic();
    this.initAddSubcategory();
    this.initCategoryForm();
  }

  manage() {
    var x = document.getElementById('manage').innerText;
    console.log(x);
    if (x === 'Manage') {
      document.getElementById('manage').innerText = 'Back';
    } else {
      document.getElementById('manage').innerText = 'Manage';
    }

    this.IsHidden = !this.IsHidden;
  }

  initAddSubcategory() {
    this.subCategoryForm = this.fb.group({
      name: ['', Validators.required],
    });
  }
  initCategoryForm() {
    this.categoryForm = this.fb.group({
      name: ['', Validators.required],
    });
  }
  initAddTopic() {
    this.topicForm = this.fb.group({
      name: ['', Validators.required],
    });
  }

  addCategory() {
    const payload = this.categoryForm.value;
    this.sub.add(
      this._category.createCategory(payload).subscribe({
        next: (res: ResponseStructure) => {
          this.categoryForm.reset();

          this.categories.push(res.responseResult);
          this._global.successHandlerWithObject(res);
        },
      })
    );
  }

  getAllCategories() {
    this._global.showSpinner();
    this.sub.add(
      this._category.getAllCategories().subscribe({
        next: (res) => {
          const categories = res['responseResult'];
          this.categories = categories;
          this._global.hideSpinner();
        },
      })
    );
  }

  getAllSubCategories(categoryId, name) {
    this._global.showSpinner();
    this.sub.add(
      this._category.getAllSubcategories(categoryId).subscribe({
        next: (res) => {
          this.subCategories = res['responseResult'];
          this.catName = name;
          this.catId = categoryId;
          this._global.hideSpinner();
          this.topics = [];
          console.log(this.subCategories);
        },
      })
    );
  }

  addSubCategory() {
    const payload = this.subCategoryForm.value;
    payload.categoryId = this.catId;

    this.sub.add(
      this._category.createSubCategory(payload).subscribe({
        next: (res: ResponseStructure) => {
          this.subCategoryForm.reset();
          this.subCategories.push(res.responseResult);
          this._global.successHandlerWithObject(res);
        },
      })
    );
  }

  addTopic() {
    const payload = this.topicForm.value;
    payload.categoryId = this.subcatId;

    this.sub.add(
      this._category.createTopic(payload).subscribe({
        next: (res: ResponseStructure) => {
          this.topicForm.reset();
          this.topics.push(res.responseResult);
          this._global.successHandlerWithObject(res);
        },
      })
    );
  }

  getAllTopics(subCategoryId, name) {
    this._global.showSpinner();
    this.sub.add(
      this._category.getllTopics(subCategoryId).subscribe({
        next: (res) => {
          this.topics = res['responseResult'];
          this.subcatName = name;
          this.subcatId = subCategoryId;
          console.log(this.topics);
          this._global.hideSpinner();
        },
      })
    );
  }

  deleteCategory(categoryId) {
    this._global.showSpinner();
    this.sub.add(
      this._category.deleteCategory(categoryId).subscribe({
        next: (res: ResponseStructure) => {
          this.categories = this.categories.filter((c) => c.id != categoryId);
          this._global.globalSuccessHandler(res);
        },
      })
    );
    console.log('deleted');
  }

  deleteTopic(topicId) {
    this._global.showSpinner();
    this.sub.add(
      this._category.deleteTopic(topicId).subscribe({
        next: (res: ResponseStructure) => {
          this.topics = this.topics.filter((t) => t.id != topicId);
          this._global.globalSuccessHandler(res);
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
